import { useFormik } from "formik"
import { isEmpty } from "lodash"
import {
  CompanyEmail, CompanyName, CompanyPhone, ContactName, ProjectName
} from "pages/Admin/ManageCompany/ManageSettingCol"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
//redux
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col, DropdownMenu,
  DropdownToggle, Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row, UncontrolledDropdown
} from "reactstrap"
import {
  deleteOrder as onDeleteOrder,
  getOrders as onGetOrders
} from "store/actions"
import * as Yup from "yup"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { companyList } from "../../../common/data/settings"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//import components
import DeleteModal from "../../../components/Common/DeleteModal"
import ManageSettingsTableContainer from "../Components/ManageSettingsTableContainer"
import EcommerceOrdersModal from "./ManageSettingsModal"

function ManageCompany() {
  //meta title
  document.title =
    "ManageSettings | TenderSoftware - Flexi TracBoard"

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [orderList, setOrderList] = useState([])
  const [order, setOrder] = useState(null)

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      companyname: (order && order.companyname) || "",
      contactname: (order && order.contactname) || "",
      companyphone: (order && order.companyphone) || "",
      companyemail: (order && order.companyemail) || "",
      projectname: (order && order.projectname) || "",
    },

    validationSchema: Yup.object({
      companyname: Yup.string().required("Please enter your Company Name"),
      contactname: Yup.string().required("Please Enter your Contact Name"),
      companyphone: Yup.string().required("Please Enter your Company Phone"),
      companyemail: Yup.string().required("Please Enter your Company Email"),
      projectname: Yup.string().required("Please Enter your Project Name"),
    }),

    onSubmit: values => {
      // if (isEdit) {
      //   const updateOrder = {
      //     id: order ? order.id : 0,
      //     orderId: values.orderId,
      //     billingName: values.billingName,
      //     orderdate: values.orderdate,
      //     total: values.total,
      //     paymentStatus: values.paymentStatus,
      //     paymentMethod: values.paymentMethod,
      //     badgeclass: values.badgeclass,
      //   }
      //   console.log("updateOrder", updateOrder)
      //   // update order
      //   dispatch(onUpdateOrder(updateOrder))
      //   validation.resetForm()
      // } else {
      //   const newOrder = {
      //     id: Math.floor(Math.random() * (30 - 20)) + 20,
      //     orderId: values["orderId"],
      //     billingName: values["billingName"],
      //     orderdate: values["orderdate"],
      //     total: values["total"],
      //     paymentStatus: values["paymentStatus"],
      //     paymentMethod: values["paymentMethod"],
      //     badgeclass: values["badgeclass"],
      //   }
      //   console.log("newOrder", newOrder)
      //   // save new order
      //   dispatch(onAddNewOrder(newOrder))
      //   validation.resetForm()
      // }
      toggle()
    },
  })

  const toggleViewModal = () => setModal1(!modal1)

  const dispatch = useDispatch()
  // const { orders } = useSelector(state => ({
  //   orders: state.ecommerce.orders,
  // }))

  const orders = companyList

  useEffect(() => {
    if (orders && !orders.length) {
      dispatch(onGetOrders())
    }
  }, [dispatch, orders])

  useEffect(() => {
    setOrderList(orders)
  }, [orders])

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders)
      setIsEdit(false)
    }
  }, [orders])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  const handleOrderClick = arg => {
    const order = arg
    setOrder({
      id: order?.id,
      companyname: order?.companyname,
      contactname: order?.contactname,
      companyphone: order?.companyphone,
      companyemail: order?.companyemail,
      projectname: order?.projectname,
    })
    setIsEdit(true)
    toggle()
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = order => {
    setOrder(order)
    setDeleteModal(true)
  }

  const handleDeleteOrder = () => {
    if (order?.id) {
      dispatch(onDeleteOrder(order))
      setDeleteModal(false)
    }
  }
  const handleOrderClicks = () => {
    setOrderList("")
    setIsEdit(false)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        Header: "Company Name",
        accessor: "companyname",
        filterable: true,
        Cell: cellProps => {
          return <CompanyName {...cellProps} />
        },
      },
      {
        Header: "Contact Name",
        accessor: "contactname",
        filterable: true,
        Cell: cellProps => {
          return <ContactName {...cellProps} />
        },
      },
      {
        Header: "Phone Number",
        accessor: "companyphone",
        filterable: true,
        Cell: cellProps => {
          return <CompanyPhone {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "companyemail",
        filterable: true,
        Cell: cellProps => {
          return <CompanyEmail {...cellProps} />
        },
      },
      {
        Header: "Project Name",
        accessor: "projectname",
        filterable: true,
        Cell: cellProps => {
          return <ProjectName {...cellProps} />
        },
      },

      // {
      //   Header: "View Details",
      //   accessor: "view",
      //   disableFilters: true,
      //   Cell: () => {
      //     return (
      //       <Button
      //         type="button"
      //         color="primary"
      //         className="btn-sm btn-rounded"
      //         onClick={toggleViewModal}
      //       >
      //         View Details
      //       </Button>
      //     )
      //   },
      // },

      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <div
              onClick={e => {
                e.stopPropagation()
              }}>
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop pointer" tag="a">
                  <i className="mdi mdi-dots-horizontal font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <div className="">
                    <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          handleOrderClick(orderData)
                        }}>
                        <i
                          className="mdi mdi-pencil font-size-18 me-2"
                          id="edittooltip"
                        />
                        Edit
                      </Link>
                    </div>
                    {/* <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          onClickDelete(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-delete font-size-16 me-2"
                          id="deletetooltip"
                        />
                        Disable
                      </Link>
                    </div> */}
                    <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          // onClickDelete(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-delete font-size-16 me-2"
                          id="deletetooltip"
                        />
                        View Employees
                      </Link>
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Ecommerce" breadcrumbItem="Orders" /> */}

          {/* <h4 className="mb-4 font-size-18">MANAGE SETTINGS</h4> */}

          <Breadcrumbs
            title={"Manage Company"}
            breadcrumbItem={"Manage Company"}
          />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <ManageSettingsTableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={false}
                    isAddOptions={true}
                    handleOrderClick={handleOrderClick}
                    customPageSize={15}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Settings" : "Add Order"}
            </ModalHeader>

            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row form>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Company/Client Name</Label>
                      <Input
                        name="companyname"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.companyname || ""}
                        invalid={
                          validation.touched.companyname &&
                          validation.errors.companyname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.companyname &&
                      validation.errors.companyname ? (
                        <FormFeedback type="invalid">
                          {validation.errors.companyname}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Contact Name</Label>
                      <Input
                        name="contactname "
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.contactname || ""}
                        invalid={
                          validation.touched.contactname &&
                          validation.errors.contactname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.contactname &&
                      validation.errors.contactname ? (
                        <FormFeedback type="invalid">
                          {validation.errors.contactname}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Phone Number</Label>
                      <Input
                        name="companyphone "
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.companyphone || ""}
                        invalid={
                          validation.touched.companyphone &&
                          validation.errors.companyphone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.companyphone &&
                      validation.errors.companyphone ? (
                        <FormFeedback type="invalid">
                          {validation.errors.companyphone}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="companyemail "
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.companyemail || ""}
                        invalid={
                          validation.touched.companyemail &&
                          validation.errors.companyemail
                            ? true
                            : false
                        }
                      />
                      {validation.touched.companyemail &&
                      validation.errors.companyemail ? (
                        <FormFeedback type="invalid">
                          {validation.errors.companyemail}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Project Name</Label>
                      <Input
                        name="projectname"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.projectname || ""}
                        invalid={
                          validation.touched.projectname &&
                          validation.errors.projectname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.projectname &&
                      validation.errors.projectname ? (
                        <FormFeedback type="invalid">
                          {validation.errors.projectname}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-primary save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
ManageCompany.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageCompany
